import React from 'react';

const ListaCompetencias = ({
  productosCompetenciasPaginados,
  competenciaLocal,
  actualizandoCompetencia,
  actualizarCompetencia
}) => {
  if (productosCompetenciasPaginados.length === 0) {
    return (
      <div className="no-productos-filtrados">
        <div className="text-center py-4">
          <i className="fas fa-search fa-2x text-muted mb-3" style={{color: '#F2A71C'}}></i>
          <h6 className="text-muted">No se encontraron competencias</h6>
          <p className="text-muted mb-3">
            No hay competencias que coincidan con los filtros aplicados
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="productos-lista">
      <div className="table-responsive">
        <table className="table table-hover">
          <thead className="table-light">
            <tr>
              <th>SKU</th>
              <th>Categoría</th>
              <th>Subcategoría</th>
              <th>Marca</th>
              <th>Competencia</th>
            </tr>
          </thead>
          <tbody>
            {productosCompetenciasPaginados.map((producto) => (
              <tr key={producto.id}>
                <td>
                  <strong>{producto.nombre}</strong>
                </td>
                <td>{producto.categoria || '-'}</td>
                <td>{producto.subcategoria || '-'}</td>
                <td>{producto.marca || '-'}</td>
                <td className="text-center">
                  <div className="form-check d-flex align-items-center justify-content-center">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      id={`competencia-${producto.id}`}
                      checked={competenciaLocal[producto.id] !== undefined 
                        ? competenciaLocal[producto.id] 
                        : Boolean(producto.competence)}
                      disabled={actualizandoCompetencia[producto.id]}
                      onChange={(e) => actualizarCompetencia(producto.id, e.target.checked)}
                      style={{transform: 'scale(1.2)'}}
                    />
                    <label 
                      className="form-check-label" 
                      htmlFor={`competencia-${producto.id}`}
                      style={{fontSize: '0.9rem', color: '#F2A71C', fontWeight: 'bold', alignItems: 'center'}}
                    >
                      {actualizandoCompetencia[producto.id] && (
                        <i className="fas fa-spinner fa-spin ms-1" style={{fontSize: '0.7rem'}}></i>
                      )}
                    </label>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListaCompetencias;
